import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "payment-details" }
const _hoisted_2 = { class: "cell" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Free actions", -1)
const _hoisted_4 = {
  key: 0,
  class: "value"
}
const _hoisted_5 = { class: "cell" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Paid actions", -1)
const _hoisted_7 = {
  key: 0,
  class: "value"
}
const _hoisted_8 = {
  key: 0,
  class: "cell"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Referrals’ billed actions", -1)
const _hoisted_10 = {
  key: 0,
  class: "value"
}
const _hoisted_11 = {
  key: 1,
  class: "cell"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Balance", -1)
const _hoisted_13 = {
  key: 0,
  class: "value"
}

import { ref } from 'vue';
import { useBillingStore } from '@/stores/billing'
import { useToastStore } from '@/stores/toast';
import CreditCardIcon from '@/components/icons/other/CreditCardIcon.vue'
import VSkeleton from '@/components/VSkeleton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentDetails',
  setup(__props) {

const billingStore = useBillingStore()
const toast = useToastStore()

const pending = ref(false)
const payNow = async () => {
  pending.value = true
  /* if (billingStore.cardInfo) {
    try {
      await billingStore.payNow()
      toast.showToast("Payment successful!", "success")
      billingStore.requestDetails()
    } catch(e) {
      toast.showToast("Payment failed")
    } finally {
      pending.value = false
    }
  } else { */
    try {
      await billingStore.addCard()
    } catch(e) {
      pending.value = false
    }
  // }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_unref(billingStore).details)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(billingStore).details.free_actions) + "/" + _toDisplayString(_unref(billingStore).details.max_free_actions), 1))
        : (_openBlock(), _createBlock(VSkeleton, {
            key: 1,
            class: "value"
          }))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      (_unref(billingStore).details)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createTextVNode(_toDisplayString(_unref(billingStore).details.paid_actions) + " (", 1),
            (_unref(billingStore).details)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass(["value", { negative: _unref(billingStore).details.pending_balance < 0, positive: _unref(billingStore).details.pending_balance > 0 }])
                }, _toDisplayString(_unref(billingStore).details.pending_balance) + "$", 3))
              : _createCommentVNode("", true),
            _createTextVNode(") ")
          ]))
        : (_openBlock(), _createBlock(VSkeleton, {
            key: 1,
            class: "value"
          })),
      _withDirectives(_createElementVNode("button", {
        class: _normalizeClass(["pay-now-button mt-2", { disabled: pending.value }]),
        onClick: payNow
      }, [
        _createVNode(CreditCardIcon),
        _createTextVNode("Add card ")
      ], 2), [
        [_vShow, !_unref(billingStore).cardInfo]
      ])
    ]),
    (_unref(billingStore).details)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          (_unref(billingStore).details)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createTextVNode(_toDisplayString(_unref(billingStore).details.referral_paid_actions) + " (", 1),
                (_unref(billingStore).details)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass(["value", { negative: _unref(billingStore).details.direct_commission_amount < 0, positive: _unref(billingStore).details.direct_commission_amount > 0 }])
                    }, _toDisplayString(_unref(billingStore).details.direct_commission_amount) + "$", 3))
                  : _createCommentVNode("", true),
                _createTextVNode(") ")
              ]))
            : (_openBlock(), _createBlock(VSkeleton, {
                key: 1,
                class: "value"
              }))
        ]))
      : _createCommentVNode("", true),
    (_unref(billingStore).details)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _hoisted_12,
          (_unref(billingStore).details)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                (_unref(billingStore).details)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass(["value", { negative: _unref(billingStore).details.balance < 0, positive: _unref(billingStore).details.balance > 0 }])
                    }, _toDisplayString(_unref(billingStore).details.balance) + "$", 3))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createBlock(VSkeleton, {
                key: 1,
                class: "value"
              }))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})